module.exports = __webpack_public_path__ + "static/media/debug.f912f892.svg";